// extracted by mini-css-extract-plugin
export default {"slideshow":"yI7103","playbackControl":"lPu9ed"};